export default "images/剩余电量-低电量.png";